import { render } from "./MenuAdmin.vue?vue&type=template&id=147b7f45&ts=true"
import script from "./MenuAdmin.vue?vue&type=script&lang=ts"
export * from "./MenuAdmin.vue?vue&type=script&lang=ts"

import "./MenuAdmin.vue?vue&type=style&index=0&id=147b7f45&lang=stylus"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__